import request from "@/utils/request";

// 登录
export const login = data => {
	return request({
		url: "/login",
		method: "POST",
		data,
	});
};

// 获取当前用户身份信息：判断当前用户是否登录，并获取其基本身份信息，如显示名称等。
export const getMyInfo = () => {
	return request({
		url: "/myinfo",
		method: "GET",
	});
};

// 修改登录用户密码
export const resetPassword = data => {
	return request({
		url: "/password",
		method: "POST",
		data,
	});
};

// 退出登录
export const logout = data => {
	return request({
		url: "/logout",
		method: "POST",
		data,
	});
};
